import { IUser } from './user'
import { IDamage, IItem } from './item'
import { IEffect } from './effect'

export const BaseStatTranslation: { [key: string]: string } = {
  hp: 'Punkty życia',
  mana: 'Punkty skupienia',
  defence: 'Obrona',
  strength: 'Siła',
  condition: 'Kondycja',
  endurance: 'Wytrzymałość',
  dexterity: 'Zręczność',
  agility: 'Zwinność',
  perception: 'Percepcja',
  intelligence: 'Inteligencja',
  wisdom: 'Mądrość',
  charisma: 'Charyzma',
  speed: 'Szybkość',
}

export const SkillTranslation: { [key: string]: string } = {
  acrobatics: 'Akrobatyka',
  alchemy: 'Alchemia',
  arcana: 'Arkana',
  art: 'Artyzm',
  athletics: 'Atletyka',
  investigation: 'Dochodzenie',
  history: 'Historia',
  intuition: 'Intuicja',
  engineering: 'Inżynieria',
  hiding: 'Krycie się',
  legerdemain: 'Kuglarstwo',
  manipulation: 'Manipulacja',
  medicine: 'Medycyna',
  occultism: 'Okultyzm',
  overawing: 'Onieśmielenie',
  persuasion: 'Perswazja',
  survival: 'Przetrwanie',
  nature: 'Przyroda',
  religion: 'Religia',
  runecraft: 'Runoznastwo',
  craft: 'Rzemiosło',
}

export interface IBaseStat {
  id?: number
  hp: number
  mana: number
  defence: number
  strength: number
  condition: number
  endurance: number
  dexterity: number
  agility: number
  perception: number
  intelligence: number
  wisdom: number
  charisma: number
  speed: number
}

export interface IRace {
  id: number
  name: string
  base_stat: IBaseStat
}

export interface ICreateCharacter {
  name: string
  race_id: number
  base_stat: IBaseStat
  skill_stat: ICharacterSkills
  weapon_profs: ICharacterWeaponProf
}

export interface IStatUpdate {
  character_id: number
  name: string
  value: string
}

export interface ICharacterWeaponProf {
  id?: number
  arms: number
  small_blades: number
  swords: number
  big_swords: number
  blunts: number
  poles: number
  bows: number
  crossbows: number
  throwing: number
}

export interface ICreateCharacterForm {
  name: string
  race_id: number
  strength: number
  condition: number
  endurance: number
  dexterity: number
  agility: number
  perception: number
  intelligence: number
  wisdom: number
  charisma: number

  acrobatics: number
  alchemy: number
  arcana: number
  art: number
  athletics: number
  investigation: number
  history: number
  intuition: number
  engineering: number
  hiding: number
  legerdemain: number
  manipulation: number
  medicine: number
  occultism: number
  overawing: number
  persuasion: number
  survival: number
  nature: number
  religion: number
  runecraft: number
  craft: number

  arms: number
  small_blades: number
  swords: number
  big_swords: number
  blunts: number
  poles: number
  bows: number
  crossbows: number
  throwing: number
}

export interface ICharacter {
  id: number
  name: string
  notes: string
  race: IRace
  skills: ICharacterSkills
  weapon_profs: ICharacterWeaponProf
  active_timed_effect_count: number
  damage: IDamage
  damage_reduction: IDamage

  hp: number
  mana: number
  max_hp: number
  max_mana: number

  strength: number
  condition: number
  endurance: number
  dexterity: number
  agility: number
  perception: number
  intelligence: number
  wisdom: number
  charisma: number

  speed: number
  lifting_capacity: number
  initiative: number
  concentration: number
  dodge: number
  block: number
  defence: number
}

export interface ICharacterItem {
  id: number
  charges: number
  amount: number
  identified: boolean
  equipped: boolean
  item: IItem
  character_id: number
}

export interface ICharacterEffect {
  id: number
  name: string
  time_left: number
  character_id: number
  effect: IEffect
}

export interface ICharacterSkills {
  id?: number
  acrobatics: number
  alchemy: number
  arcana: number
  art: number
  athletics: number
  investigation: number
  history: number
  intuition: number
  engineering: number
  hiding: number
  legerdemain: number
  manipulation: number
  medicine: number
  occultism: number
  overawing: number
  persuasion: number
  survival: number
  nature: number
  religion: number
  runecraft: number
  craft: number
}

export interface IStatRoll {
  game_id: number
  stat_attr: string
}

export interface IDmgRoll {
  game_id: number
  dmg_type: string
  dmg_kind: string
  range: string
}

export interface ISkillRoll {
  game_id: number
  skill_attr: string
}

export interface IDiceRoll {
  game_id: number
  count: number
  dice: number
  mod: number
}

export interface IGameCharacter {
  id: number
  game_id: number
  user: IUser
  character: ICharacter
}
